import { render, staticRenderFns } from "./MilkVatCorrectionsSettings.vue?vue&type=template&id=51aafae0&"
import script from "./MilkVatCorrectionsSettings.vue?vue&type=script&lang=ts&"
export * from "./MilkVatCorrectionsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports